import { WorkItemType } from '@/types';

const TYPE_TO_SLUG: Record<WorkItemType, string> = {
  [WorkItemType.EPIC]: 'epic',
  [WorkItemType.FEATURE]: 'feature',
  [WorkItemType.USER_STORY]: 'userstory',
  [WorkItemType.TASK]: 'task',
  [WorkItemType.BUG]: 'bug',
};

const SLUG_TO_TYPE: Record<string, WorkItemType> = {
  epic: WorkItemType.EPIC,
  feature: WorkItemType.FEATURE,
  userstory: WorkItemType.USER_STORY,
  task: WorkItemType.TASK,
  bug: WorkItemType.BUG,
};

export function workItemTypeFromSlug(slug: string | undefined): WorkItemType | undefined {
  if (!slug) return undefined;
  return SLUG_TO_TYPE[slug.toLowerCase()];
}

export function getWorkItemSlug(type: WorkItemType): string {
  return TYPE_TO_SLUG[type] ?? 'task';
}

/** Path segment for permalinks, e.g. `/userstory/100` or `/task/174`. */
export function getWorkItemPath(task: {
  type: WorkItemType;
  sequenceNumber?: number | null;
  id: string;
}): string {
  const slug = getWorkItemSlug(task.type);
  const ref = task.sequenceNumber ?? task.id;
  return `/${slug}/${ref}`;
}

export function getWorkItemUrl(
  task: { type: WorkItemType; sequenceNumber?: number | null; id: string },
  origin: string = typeof window !== 'undefined' ? window.location.origin : '',
): string {
  return `${origin}${getWorkItemPath(task)}`;
}

export type TaskLookupArg = string | { ref: string; type: string };

export function buildTaskLookupArg(
  ref: string | undefined,
  typeSlug?: string,
): TaskLookupArg | undefined {
  if (!ref) return undefined;
  if (typeSlug && /^\d+$/.test(ref)) {
    return { ref, type: typeSlug };
  }
  return ref;
}
